import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'apparel_discovery-showroom_v2-click';
/**
 * click event for showroom v2
 */
export function trackApparelDiscoveryShowroomV2Click(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken,
            customParameterToken2,
            customParameterToken3,
        },
    });
}
